const first = (buf) => buf[0];
const peek = (buf) => buf[buf.length - 1];
export {
  first,
  peek
};
